import { IconButton } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';

PdfPopupButton.propTypes = {
  url: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.node,
  largeTooltip: PropTypes.bool,
  row: PropTypes.object,
};

export default function PdfPopupButton({ url, icon, tooltipText, row, largeTooltip = false }) {
  const disabled = !url;

  const handleClick = () => {
    if (disabled) return;
    const modal = document.createElement('div');
    modal.style.position = 'fixed';
    modal.style.zIndex = '100000';
    modal.style.left = '0';
    modal.style.bottom = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    modal.style.display = 'flex';
    modal.style.justifyContent = 'center';
    modal.style.alignItems = 'center';

    const iframe = document.createElement('iframe');
    iframe.style.width = '70%';
    iframe.style.height = '100%';
    iframe.src = url;

    modal.appendChild(iframe);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) document.body.removeChild(modal);
    });
    document.body.appendChild(modal);
  };

  const WrapperTooltip = largeTooltip ? NoMaxWidthTooltip : Tooltip;

  return (
    <WrapperTooltip placement="left" title={tooltipText} arrow>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'rgb(241,158,59,1)',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            transform: 'translate(-30%, -30%)',
          }}
        >
          <Chip
            size="small"
            label={row?.mainFileNumPages || ''}
            sx={{
              color: 'rgb(241,158,59,1)',
              backgroundColor: 'rgba(241, 158, 59, 0.1)',
            }}
          />
        </div>
        <IconButton size="small" sx={{ p: 0.5 }} color="warning" onClick={handleClick} disabled={disabled}>
          {icon}
        </IconButton>
      </div>
    </WrapperTooltip>
  );
}

const NoMaxWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    maxHeight: 'none',
    height: '80vh',
    width: '50vw',
  },
});